import { AnimationFrame } from "../reducers/animation-default-state";
import { RootState } from "../store";

type AnimationFrameWithIndex = AnimationFrame & { index: number };

export const framePickerSelector = (state: RootState) => {
  const { animation, editor } = state;
  const { framePickerLayerMode: visibleLayers } = editor;
  const { sequence } = animation;

  const imagesUsed = new WeakMap();
  const uniqueSequenceItems: AnimationFrameWithIndex[] = [];

  sequence.forEach((sequenceItem, index) => {
    const filteredLayers = sequenceItem.layers.filter(
      (layer, index) => visibleLayers[index],
    );

    if (filteredLayers.some((layer) => !imagesUsed.has(layer.image))) {
      filteredLayers.forEach((layer) => imagesUsed.set(layer.image, true));
      uniqueSequenceItems.push({
        ...sequenceItem,
        layers: filteredLayers,
        index,
      });
    }
  });

  return uniqueSequenceItems;
};
